export default {
    cta: "Pregúntale a un<br/> Tutor",
    ordered: "Pedido el {date}"
}